/** Microsoft Teams mark. Sized in px because it is an SVG viewport, not layout. */
export function TeamsLogo({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <path
        d="M29.4 18.6h13.2c1.2 0 2.2 1 2.2 2.2v11.5c0 4.4-3.6 8-8 8h-.1c-4.4 0-8-3.6-8-8V18.6z"
        fill="#5059C9"
      />
      <circle cx="38.6" cy="11.4" r="4.4" fill="#5059C9" />
      <circle cx="25.6" cy="9.6" r="6.2" fill="#7B83EB" />
      <path
        d="M32.5 18.6H16.1c-1.2 0-2.2 1-2.2 2.2v14.4c0 6 4.9 10.8 10.9 10.8 6 0 10.9-4.8 10.9-10.8V20.8c0-1.2-1-2.2-2.2-2.2z"
        fill="#7B83EB"
      />
      <path
        d="M25.1 15.8H14.6v20.5c0 .3 0 .5.1.8h10.4c1.2 0 2.2-1 2.2-2.2V18c0-1.2-1-2.2-2.2-2.2z"
        fill="#000"
        fillOpacity="0.1"
      />
      <rect x="2" y="12.4" width="21.4" height="21.4" rx="2" fill="#4B53BC" />
      <path d="M18.2 18.1H7.2v2.4h4.1V31h2.8V20.5h4.1v-2.4z" fill="#fff" />
    </svg>
  );
}
